
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class FixedPhraseTreeViewerMixin extends Mixins() {
  notifyMessage(key: string): void {
    try {
      const message = this.createPostMessage(key);
      if (!!window.opener) {
        (window.opener as Window).postMessage(message, "*");
      }
      if (!!window.parent) {
        (window.parent as Window).postMessage(message, "*");
      }
    } catch (e) {
      console.log(e);
    }
  }

  createPostMessage(key: string): string {
    const message = {
      key,
    };
    return JSON.stringify(message);    
  }
}
